import React from 'react';
import { X } from 'lucide-react';

interface AddCategoryModalProps {
    onClose: () => void;
    newCategoryForm: {
        name: string;
        description: string;
        color: string;
    };
    setNewCategoryForm: (form: any) => void;
    onCreateCategory: () => void;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
    onClose,
    newCategoryForm,
    setNewCategoryForm,
    onCreateCategory,
}) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
                <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-semibold text-gray-900">Yeni Kategori Ekle</h2>
                        <button
                            onClick={onClose}
                            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
                        >
                            <X className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Kategori Adı *
                        </label>
                        <input
                            type="text"
                            value={newCategoryForm.name}
                            onChange={(e) =>
                                setNewCategoryForm({ ...newCategoryForm, name: e.target.value })
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Örn: Sözleşmeler, Dilekçeler..."
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Açıklama
                        </label>
                        <textarea
                            value={newCategoryForm.description}
                            onChange={(e) =>
                                setNewCategoryForm({ ...newCategoryForm, description: e.target.value })
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Kategori açıklaması (opsiyonel)..."
                            rows={2}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Renk</label>
                        <div className="flex items-center space-x-3">
                            <input
                                type="color"
                                value={newCategoryForm.color}
                                onChange={(e) =>
                                    setNewCategoryForm({ ...newCategoryForm, color: e.target.value })
                                }
                                className="w-12 h-10 border border-gray-300 rounded-lg cursor-pointer"
                            />
                            <div className="flex space-x-2">
                                {[
                                    '#3B82F6',
                                    '#10B981',
                                    '#F59E0B',
                                    '#EF4444',
                                    '#8B5CF6',
                                    '#06B6D4',
                                ].map((color) => (
                                    <button
                                        key={color}
                                        onClick={() => setNewCategoryForm({ ...newCategoryForm, color })}
                                        className={`w-8 h-8 rounded-lg border-2 ${newCategoryForm.color === color
                                                ? 'border-gray-400'
                                                : 'border-gray-200'
                                            }`}
                                        style={{ backgroundColor: color }}
                                        title={color}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex space-x-3 pt-4">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            İptal
                        </button>
                        <button
                            onClick={onCreateCategory}
                            disabled={!newCategoryForm.name.trim()}
                            className={`flex-1 px-4 py-2 rounded-lg transition-colors ${!newCategoryForm.name.trim()
                                    ? 'bg-gray-400 text-white cursor-not-allowed'
                                    : 'bg-blue-900 text-white hover:bg-blue-800'
                                }`}
                        >
                            Kategori Oluştur
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCategoryModal;
